// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FileUpload_wrapper__SYjvp","upload":"FileUpload_upload__kS6tm","helpText":"FileUpload_helpText__suoJL","label":"FileUpload_label__So0S3"};